import React, { createContext, useContext } from 'react';

const defaultValue = {
  refresh: () => {},
  refreshInbox: () => {},
  badge: { approve: 0, cc: 0, initiated: 0, drafts: 0, total: 0 }
};

const ApprovalNotifyContext = createContext(defaultValue);

export const ApprovalNotifyProvider = ({ value, children }) => (
  <ApprovalNotifyContext.Provider value={value}>{children}</ApprovalNotifyContext.Provider>
);

export const useApprovalNotifyContext = () => useContext(ApprovalNotifyContext);
